import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { base44 } from '@/api/base44Client';
import PageNotFound from '@/lib/PageNotFound';

// Resolves a clean partner referral URL (orthocare.pt/CODE).
// If the code belongs to an approved partner, persist it in localStorage
// (same key PartnerReferralCapture uses) and redirect to the booking
// search page (/start) so the visitor can search and reserve, and the
// booking flow attaches the partner code to the reservation. Otherwise
// render 404 to preserve SEO for genuinely unknown single-segment URLs.
export default function PartnerReferralRedirect() {
  const { code } = useParams();
  const [state, setState] = useState('checking'); // checking | valid | invalid

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await base44.functions.invoke('validatePartnerReferral', { code });
        if (!alive) return;
        const valid = res?.valid ?? res?.data?.valid;
        if (valid) {
          try { localStorage.setItem('partnerReferralCode', code.trim().toLowerCase()); } catch (_) {}
          setState('valid');
        } else {
          setState('invalid');
        }
      } catch (_) {
        if (alive) setState('invalid');
      }
    })();
    return () => { alive = false; };
  }, [code]);

  if (state === 'valid') return <Navigate to="/start" replace />;
  if (state === 'invalid') return <PageNotFound />;
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" />
    </div>
  );
}